import { useEffect, useRef, useState } from "react";
import exportIcon from "../images/export-icon.svg";
import exportIconWhite from "../images/export-icon-white.svg";
import axios from "axios";
import { Cookies } from "react-cookie";

interface ExportGoalButtonProps {
    courseId: number;
    semesterId: number;
    isIndividual?: boolean;
    isScholarship?: boolean;
}

interface ExportGoalProps {
    handleDownloadFileExcel: () => void;
    isIndividual?: boolean;
    isScholarship?: boolean;
}

export default function ExportGoalButton({ courseId, semesterId, isIndividual, isScholarship }: ExportGoalButtonProps) {

    const [showExportGoal, setShowExportGoal] = useState(false)
    const cookies = new Cookies();

    const handleClickExportGoal = () => {
        setShowExportGoal(prev => !prev)
    }

    const handleDownloadFileExcel = () => {
        const fetchURL = "CommonGoals"
        axios.get(`/${fetchURL}/excel?semesterId=${semesterId}&curriculumId=${courseId}`, {
            headers: {
                'Authorization': `Bearer ${cookies.get('user')?.token}`
            },
            responseType: 'blob',
        }).then((response) => {
            const url = window.URL.createObjectURL(new Blob([response.data]))
            let link = document.createElement('a')
            link.setAttribute('style', 'display: none')
            link.href = url
            link.setAttribute('target', '_blank')
            link.setAttribute('download', `${semesterId}-${courseId}_Common Goals_${new Date().toDateString()}.xlsx`)
            link.click()
            link.remove()
            setTimeout(() => {
                window.URL.revokeObjectURL(url)
                setShowExportGoal(false)
            }, 100)
        }).catch((error) => {

        });
    }

    const goalMenuRef = useRef<HTMLDivElement>(null);

    useEffect(() => {
        document.addEventListener("mousedown", (event) => {
            if (goalMenuRef.current && !goalMenuRef.current.contains(event.target as Element)) {
                setShowExportGoal(false);
            }
        })
    })

    return (
        <div className="goal-menu-btn-container" ref={goalMenuRef}>
            <button className="page-btn gap-dot5" onClick={handleClickExportGoal}>
                <span><img src={exportIcon} alt="export" /></span>
                <span>Export</span>
            </button>
            {showExportGoal && <ExportGoal handleDownloadFileExcel={handleDownloadFileExcel}/>}
        </div>
    )
}

function ExportGoal({ isIndividual, isScholarship, handleDownloadFileExcel }: ExportGoalProps) {
    let goal = "Common Goals"
    if (isIndividual) {
        goal = "Individual Goals"
    } else if (isScholarship) {
        goal = "Scholarships"
    }
    return (
        <div className="goal-menu">
            <div className="goal-menu-wrapper">
                <div className="goal-menu-title">
                    <h3>Export Goal</h3>
                    <p>Download {goal} as Excel</p>
                </div>
                <div className="goal-menu-bottom-container">
                    <button className="main-btn gap-dot5" onClick={handleDownloadFileExcel}>
                        <span><img src={exportIconWhite} alt="Download" /></span>
                        <span>Download</span>
                    </button>
                </div>
            </div>
        </div>
    )
}
